import React, { useMemo, useState } from 'react';
import { PDFDownloadLink} from '@react-pdf/renderer';
import { FiEye, FiDownload } from 'react-icons/fi';
import InvoicePDF from './Invoice'; // Confirm it's the default export
import { pdf } from '@react-pdf/renderer';


const prepareInvoiceData = (employeeName, formName, amount, transactionID, timestamp) => ({
  employeeName: employeeName,
  formName: `${formName}`,
  amount: amount,
  transactionID: transactionID,
  timestamp: timestamp
});

export const InvoiceDownloadButton = ({ employeeName, formName, amount, transactionID, timestamp }) => {
  const invoiceData = useMemo(() => prepareInvoiceData(employeeName, formName, amount, transactionID, timestamp), [
    employeeName,
    formName,
    amount,
    transactionID,
    timestamp
  ]);

  const safeName = employeeName || 'unknown';
const fileName = `invoice-${safeName.replace(/\s+/g, '-')}-${new Date().toISOString().slice(0, 10)}.pdf`;


  return (
    <PDFDownloadLink document={<InvoicePDF {...invoiceData} />} fileName={fileName} className="w-full">
      {({ loading }) => (
        <button
          className={`w-full flex items-center justify-between px-4 py-3 ${
            loading ? 'bg-gray-100' : 'bg-blue-50 hover:bg-blue-100'
          } border border-blue-200 rounded-lg transition-colors`}
          disabled={loading}
        >
          <div className="flex items-center">
            <FiDownload className="text-blue-600 mr-3" />
            <span className="text-sm font-medium text-gray-800">
              {loading ? 'Generating Invoice...' : 'Download Invoice'}
            </span>
          </div>
        </button>
      )}
    </PDFDownloadLink>
  );
};

export const InvoiceViewButton = ({ employeeName, formName, amount, transactionID, timestamp }) => {
  const invoiceData = useMemo(() => ({
    employeeName: employeeName,
    formName: `${formName}`,
    amount: amount,
    transactionID: transactionID,
    timestamp: timestamp
  }), [employeeName, formName, amount, transactionID, timestamp]);

  const handleView = async () => {
    const blob = await pdf(<InvoicePDF {...invoiceData} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleView}
      className="w-full flex items-center justify-between px-4 py-3 bg-purple-50 hover:bg-purple-100 border border-purple-200 rounded-lg transition-colors duration-200"
    >
      <div className="flex items-center">
        <FiEye className="text-purple-600 mr-3" />
        <span className="text-sm font-medium text-gray-800">View Invoice</span>
      </div>
    </button>
  );
};
